module.exports = __webpack_public_path__ + "static/media/create-assignment.c11558c7.png";